<template>
  <VMain>
    <VContainer>
      <div
        v-if="showLoader"
        class="d-flex align-center"
        style="min-height: 80vh"
      >
        <v-progress-circular
          v-if="showLoader"
          class="mx-auto"
          indeterminate
          color="#72AFE7"
        ></v-progress-circular>
      </div>
      <div v-else>
        <div v-if="!edit">
          <VRow class="card__manage" align="end" v-if="!$vuetify.breakpoint.xs">
            <h1 class="mt-5">
              <img src="@/assets/my-business.png" class="icon mr-5" />{{
                "manage_profile_title" | localize
              }}
            </h1>
            <VSpacer />
            <VBtn
              color="#72AFE7"
              dark
              class="d-flex my-auto ml-auto font-weight-bold mt-5"
              @click="pushCreateUser"
              >{{ "button_add_business_profile_user" | localize }}</VBtn
            >
          </VRow>
          <VCard v-else>
            <VRow class="px-5">
              <VIcon v-if="!$vuetify.breakpoint.smAndDown" class="mt-5 mb-5"
                >mdi-store</VIcon
              >
              <div v-else>
                <img
                  width="42px"
                  height="40px"
                  src="@/assets/businesses/shopIcon.png"
                  alt="shop"
                  class="mt-4 mb-4"
                  style="margin-right: 14px"
                />
              </div>
              <h2 class="mt-5 mb-5 ml-1">
                {{ "manage_profile_title" | localize }}
              </h2>
              <VBtn
                color="#72AFE7"
                dark
                outlined
                style="border: 1px solid #72afe7"
                class="d-flex my-auto ml-auto mx-auto mx-md-0 mt-0 mt-md-5 mb-5 black--text"
                @click="pushCreateUser"
              >
                <span>
                  + {{ "button_add_business_profile_user" | localize }}
                </span>
              </VBtn>
            </VRow>
          </VCard>

          <!-- card list users -->
          <VCard evalution="5" class="mt-5">
            <div
              v-if="managers.length === 0"
              class="d-flex align-center justify-center"
              style="min-height: 40vh"
            >
              <span>You don't have manager users now{{ "" | localize }}</span>
            </div>
            <VSimpleTable class="w-auto" v-else>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      <h3>ID</h3>
                    </th>
                    <th class="text-left">
                      <h3>{{ "manage_users_datatable_name" | localize }}</h3>
                    </th>
                    <th class="text-left">
                      <h3>{{ "manage_users_role" | localize }}</h3>
                    </th>
                    <th class="text-left">
                      <h3>{{ "manage_users_actions" | localize }}</h3>
                    </th>
                  </tr>
                </thead>
                <tbody v-for="manager in managers" :key="manager.id">
                  <tr>
                    <td class="text-left">
                      <h4>{{ manager.user_id || manager.id }}</h4>
                    </td>
                    <td class="text-left">
                      <label
                        >{{ manager.first_name }} {{ manager.last_name }}</label
                      >
                    </td>
                    <td
                      class="text-left"
                      v-for="role in manager.business"
                      :key="role.role_id"
                    >
                      <h4 class="h4_view">
                        {{ role.role_name }} -
                        <i>
                          <router-link
                            :to="{
                              name: 'businessInfo',
                              params: { bid: role.shop_uid },
                            }"
                          >
                            <a class="a_mobile">{{
                              role.shop_name
                            }}</a></router-link
                          >
                        </i>
                      </h4>
                    </td>
                    <td
                      class="text-left"
                      v-for="role in manager.organisations"
                      :key="role.id"
                    >
                      <h4 class="h4_view">
                        {{ role.role_name }} -
                        <i>
                          <router-link
                            :to="{
                              name: 'info',
                              params: { sid: role.social_uid },
                            }"
                          >
                            <a class="a_mobile">{{ role.name }}</a></router-link
                          >
                        </i>
                      </h4>
                    </td>
                    <td>
                      <VRow dense v-if="!$vuetify.breakpoint.xs">
                        <VCol cols="auto">
                          <VBtn
                            outlined
                            :width="$vuetify.breakpoint.xs ? '5%' : ''"
                            color="#72AFE7"
                            class="btn__edit mt-2"
                            @click="editManager(manager.uid)"
                          >
                            {{ "manage_profile_btn_edit" | localize }}
                          </VBtn>
                        </VCol>
                        <VCol>
                          <VBtn
                            color="#72AFE7"
                            class="btn__delete mt-2"
                            dark
                            @click="(visible = true), (uid = manager.uid)"
                            >{{ "manage_profile_btn_delete" | localize }}</VBtn
                          >
                        </VCol>
                      </VRow>
                      <VRow v-else justify="center">
                        <VIcon
                          color="#72AFE7"
                          @click="editManager(manager.uid)"
                        >
                          mdi-pencil</VIcon
                        >
                        <VIcon
                          class="ml-2"
                          color="error"
                          @click="(visible = true), (uid = manager.uid)"
                        >
                          mdi-close-circle</VIcon
                        >
                      </VRow>
                    </td>
                  </tr>
                </tbody>
              </template>
            </VSimpleTable>
          </VCard>
          <delete-confirm-modal
            :visibility="visible"
            @close="visible = false"
            @delete="deleteManager(uid)"
          />
        </div>
      </div>
    </VContainer>
  </VMain>
</template>

<script>
import ManagerService from "@/requests/Manager/ManagerService";
import DeleteConfirmModal from "@/components/ManageUsers/DeleteConfirmModal";
import { mapGetters } from "vuex";

export default {
  components: {
    DeleteConfirmModal,
  },
  data: () => ({
    managers: [],
    edit: false,
    uid: "",
    visible: false,
    showLoader: true,
  }),
  mounted() {
    this.getListManager();
  },
  computed: {
    ...mapGetters(["loggedUser"]),
  },
  watch: {
    "loggedUser.locale": {
      handler() {
        this.getListManager();
      },
    },
  },
  methods: {
    pushCreateUser() {
      this.$router.push({
        name: "create_user",
      });
    },
    async getListManager() {
      try {
        let response = await ManagerService.listManager();
        this.managers = response.result;
        console.log("manage", response.result);
        this.showLoader = false;
      } catch (e) {
        this.showLoader = false;
      }
    },
    async deleteManager(uid) {
      try {
        await ManagerService.deleteManager(uid);
        this.getListManager();
        this.visible = false;
      } catch (e) {
        this.showLoader = false;
      }
    },
    editManager(uid) {
      this.$router.push({ name: "edit_user", params: { uid: uid } });
    },
  },
};
</script>

<style scoped>
.btn__edit {
  font-weight: bold;
  width: 160px;
}
.btn__delete {
  font-weight: bold;
  width: 160px;
}
.h4_view {
  color: #6b444a;
}
.card__manage {
  margin-top: 50px;
  margin-bottom: 20px;
}
a {
  font-weight: bold;
  color: #72afe7;
  text-decoration: none !important;
}
</style>